import { logger } from "@/lib/logger";

type LogLevel = "debug" | "info" | "warn" | "error";

export const createLogAdapter = (module: string) => {
	const log = logger.child({ module });

	const emit = (level: LogLevel, message: string, args: unknown[]) => {
		if (args.length === 0) {
			log[level](message);
			return;
		}
		if (args.length === 1 && args[0] instanceof Error) {
			log[level](message, { error: args[0] });
			return;
		}
		if (
			args.length === 1 &&
			typeof args[0] === "object" &&
			args[0] !== null &&
			!Array.isArray(args[0])
		) {
			log[level](message, { data: args[0] as Record<string, unknown> });
			return;
		}
		if (args.length === 1) {
			log[level](message, { data: { value: args[0] } });
			return;
		}
		log[level](message, { data: { args } });
	};

	return {
		debug: (message: string, ...args: unknown[]) =>
			emit("debug", message, args),
		info: (message: string, ...args: unknown[]) =>
			emit("info", message, args),
		warn: (message: string, ...args: unknown[]) =>
			emit("warn", message, args),
		error: (message: string, ...args: unknown[]) =>
			emit("error", message, args),
	};
};
